<template>
  <div class="template">
    <el-dialog
      title="选择资产"
      top="5vh"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-top">
        <el-input
          v-model="searchData.Keyword"
          clearable
          placeholder="请输入资产信息名称"
          style="width: 300px; margin-left: 10px"
        ></el-input>
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <div class="dialog-center" v-loading="loading">
        <el-table
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 40px)"
          :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>
          <el-table-column
            label="资产编号"
            align="center"
            prop="AssetCode"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="资产名称"
            align="center"
            prop="AssetName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="资产类型"
            align="center"
            prop="AssetTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="资产分类"
            align="center"
            prop="AssetCategoryName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="资产规格型号"
            align="center"
            prop="AssetSpec"
            sortable
          >
          </el-table-column>

          <el-table-column label="数量" align="center" prop="Qty" sortable>
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
            prop="StatusName"
            sortable
          >
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      templateValue: '',
      searchData: {
        Condition: 'Asset',
        Keyword: '',
      },
      selectRows: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],

      loading: false,
      selectedRows: [],
    }
  },
  props: {
    type: { default: 'checkBox', require: false, type: String },
  },
  methods: {
    confirm() {
      console.log(this.selectRows, '')
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择')
      }
      this.$emit('select', [...this.selectRows])
      this.dialogVisible = false
    },
    handleRowClick(row) {
      if (this.type == 'checkBox') {
        this.$refs.dialogTable.toggleRowSelection(row)
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/am_asset/GetSpecificDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            this.$refs.dialogTable.clearSelection()
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openDialog() {
      this.dialogVisible = true
      this.searchData.Keyword = ''
      this.handleSearch()
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    value(newValue) {
      this.templateValue = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.dialog-top {
  line-height: 30px;
}
.dialog-center {
  height: calc(70vh - 30px);
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
